import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { backendURL } from '../IPaddress';
import '../CSS/CRUDfiles.css';
import 'bootstrap-icons/font/bootstrap-icons.css';


const SiteContentComponent = () => {
  const [contentList, setContentList] = useState([]);
  const [currentContent, setCurrentContent] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showSaved, setShowSaved] = useState(false);
  const { authState } = useAuth();
  const navigate = useNavigate();

  // Authentication check
  useEffect(() => {
    if (!authState) {
      navigate('/login');
    }
  }, [authState, navigate]);

  // Fetch all editable content
  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    const response = await fetch(`${backendURL}/api/site-content`, {
      method: 'GET',
      credentials: 'include'
    });
    if (response.ok) {
      const data = await response.json();
      setContentList(Array.isArray(data) ? data : []);
    } else {
      setErrorMessage('Unable to load editable text. Please try again later.');
    }
  };

  const handleFormChange = (e) => {
    setCurrentContent({ ...currentContent, [e.target.name]: e.target.value });
  };

  const editContent = (content) => {
    setCurrentContent(content);
    setShowForm(true);
  };

  const handleCancel = () => {
    setCurrentContent(null);
    setShowForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentContent.content_value || currentContent.content_value.trim() === '') {
      setErrorMessage('Text cannot be empty.');
      return;
    }

    const response = await fetch(`${backendURL}/api/site-content/${currentContent.content_id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content_key: currentContent.content_key,
        content_value: currentContent.content_value,
        description: currentContent.description
      }),
      credentials: 'include'
    });

    if (response.ok) {
      setCurrentContent(null);
      setShowForm(false);
      setShowSaved(true);
      fetchContent();
    } else {
      setErrorMessage('Failed to save changes. Please try again.');
    }
  };

  return (
    <div>
      <p className="text-muted">
        Edit the wording shown to users on public pages. Changes take effect immediately the next time the page is loaded.
      </p>

      {showForm && currentContent ? (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="content_description" className="mb-2">
            <Form.Label>What this text is</Form.Label>
            <Form.Control type="text" value={currentContent.description || currentContent.content_key} readOnly disabled />
          </Form.Group>
          <Form.Group controlId="content_value" className="mb-2">
            <Form.Label>Text</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="content_value"
              onChange={handleFormChange}
              value={currentContent.content_value}
            />
          </Form.Group>
          <Button type="submit" className="m-1">Save</Button>
          <Button variant="secondary" onClick={handleCancel} className="ml-2">Cancel</Button>
        </Form>
      ) : (
        <div className="scrollable-table">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>What this text is</th>
                <th>Current text</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {contentList.map((content) => (
                <tr key={content.content_id}>
                  <td>{content.description || content.content_key}</td>
                  <td>{content.content_value}</td>
                  <td>
                    <Button onClick={() => editContent(content)} className="m-1">
                      <i className="bi bi-pencil-square"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      <Modal show={showSaved} onHide={() => setShowSaved(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Saved</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your text changes have been saved.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSaved(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={Boolean(errorMessage)} onHide={() => setErrorMessage(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setErrorMessage(null)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SiteContentComponent;
